// Thank-you page content — Croatian only (as per spec).
const thankYouContent = {
  title: "Hvala vam na povjerenju",
  subtitle: "Vaša poruka je uspješno poslana.",
  body: "Naš investicijski savjetnik pregledat će vaš upit i javiti vam se putem e-adrese unutar dva radna dana. U međuvremenu vas pozivamo da pregledate aktivne projekte i saznate više o načinu ulaganja.",
  emailNote: "Ako je potrebno hitno, javite nam se izravno:",
  emailAddress: "info@zyravex.com",
  backHome: "Natrag na naslovnicu",
  smallPrint: "Automatska potvrda će stići na vašu e-adresu. Ako je ne pronađete, provjerite mapu neželjene pošte."
};

export default thankYouContent;
